@if (account$ | async; as account) {
  <div class="block-content-round">
    <div class="ion-grid-padding">
      <p class="ion-margin-top-0">
        <strong>{{ account.company.name }}</strong>
      </p>
      <p class="fs-sm ion-color-medium">
        {{ account.company.postalCode }} {{ account.company.city }} ({{ account.company.stateProvince }}),
        {{ account.company.country }}
      </p>
    </div>
  </div>
}
